import * as Website from '../../Config/Website.js';
import * as OverviewParallax from './Modules/OverviewParallax.js';


const preinit = () => {

}

const init = () => {
  OverviewParallax.init();
}

const pageChanged = () => {
  OverviewParallax.init();
}

const resize = () => {
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}